<template>
    <div>
        <h1 class="display-heading">Change Email Address</h1>
        <form @submit.prevent="submitChangePassword">
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Current Email Address</label>

                        <p>
                            <b>
                                {{ $store.state.user.email }}
                            </b>
                        </p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group required">
                        <label>New Login Email Address</label>

                        <input type="text" name="newEmailAddress" ref="newEmailAddress" data-vv-as="new email address" data-vv-validate-on="blur"
                            placeholder="Enter New Email Address" v-model="newEmailAddress" v-validate="'required|email'"
                            :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('newEmailAddress')
                            }">

                        <div v-show="validationErrors.has('newEmailAddress')" class="invalid-feedback">
                            {{ validationErrors.first('newEmailAddress') }}
                        </div>
                    </div>
                </div>
            </div>

            <p :class="{
                'text-danger': !submitSuccess
            }">
                {{ changeEmailMessage }}
            </p>

            <button @click="submit" class="btn btn-primary btn-primary-insv mr-2" type="button">Request to Change Login Email Address</button>
            <button @click="cancel" class="btn btn-secondary" type="button">Cancel</button>
        </form>
    </div>
</template>

<script>
export default {
    'name': 'ChangeEmailAddress',
    data () {
        return {
            'newEmailAddress': '',
            'changeEmailMessage': '',
            'submitSuccess': true
        };
    },
    'methods': {
        submit () {
            this.$validator.validateAll().then((isValid) => {
                this.submitSuccess = true;
                this.changeEmailMessage = 'Submitting your request...';
                if (isValid) {
                    this.axios.post('Account/ChangeEmailAddress', {
                        'e': this.newEmailAddress
                    }).then(() => {
                        this.submitSuccess = true;
                        this.changeEmailMessage = 'Your request has been processed. Please check your e-mail for the instructions to update your login email address.';
                        this.cancel();
                    }).catch((e) => {
                        this.submitSuccess = false;
                        if (e.response && e.response.data && e.response.data.message) {
                            this.changeEmailMessage = e.response.data.message;
                        } else {
                            this.changeEmailMessage = 'Error submitting your request. Please try again.';
                        }
                    });
                }
            });
        },
        cancel () {
            this.newEmailAddress = '';
            this.$validator.reset();
        }
    }
};
</script>
